angular.module("tromanWeb").factory('browserService', [function () {

    var so = {};

    var NEXTNAMEID = 0;
    so.openChildWindow = function openChildWindow(url, name, params) {
        window.childParams = window.childParams || {};
        name = name || ("CHILD" + (NEXTNAMEID++));
        window.childParams[name] = params;
        var win = window.open(url, name);
        return win;
    };

    return so;

}]);
